import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'
import axios from 'axios';

const store = genBasicStore('combo')

store.actions.toggleRun = function ({ commit }, id) {
  return axios.post(`/combos/${id}/run`);
}

export default store;
